/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CreatedInputs */

const en_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const es_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const created = /** @type {((inputs?: CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_created(inputs)
	return es_created(inputs)
});